export default __webpack_public_path__ + "pr.jpg?2b50ab9041ac8432bca44308d78cb42b";